// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "react-dom", "../Typography", "../Button", "../Icon"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("react-dom"), require("../Typography"), require("../Button"), require("../Icon"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.reactDom, global.Typography, global.Button, global.Icon);
    global.Modal = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _reactDom, _Typography, _Button, _Icon) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Modal = void 0;
  _react = _interopRequireWildcard(_react);
  _reactDom = _interopRequireDefault(_reactDom);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  var Modal = _exports.Modal = function Modal(_ref) {
    var title = _ref.title,
      children = _ref.children,
      open = _ref.open,
      onClose = _ref.onClose,
      secondaryLabel = _ref.secondaryLabel,
      primaryLabel = _ref.primaryLabel,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      onPrimaryClick = _ref.onPrimaryClick,
      onSecondaryClick = _ref.onSecondaryClick;
    var dialogRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(function () {
      if (dialogRef.current) {
        if (open) {
          dialogRef.current.showModal();
        } else {
          dialogRef.current.close();
        }
      }
    }, [open]);
    var modalContent = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, open && /*#__PURE__*/_react["default"].createElement("div", {
      className: "cop-fixed cop-inset-0 cop-z-50 cop-overflow-hidden cop-bg-backDrop cop-opacity-100 cop-transition-opacity cop-duration-0 cop-ease-in-out",
      onClick: onClose
    }), /*#__PURE__*/_react["default"].createElement("dialog", {
      ref: dialogRef,
      onClick: onClose,
      className: "".concat(className, " cop-w-118 cop-overflow-hidden cop-rounded cop-border cop-border-solid cop-border-secondary cop-bg-white cop-p-0 cop-shadow-popover")
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "cop-relative"
    }, /*#__PURE__*/_react["default"].createElement("header", {
      className: "cop-sticky cop-top-0 cop-border-0 cop-border-b cop-border-solid cop-border-card-border cop-bg-white"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "cop-flex cop-items-center cop-justify-between cop-px-5 cop-py-4"
    }, /*#__PURE__*/_react["default"].createElement(_Typography.Heading, {
      variant: "base"
    }, title !== null && title !== void 0 ? title : 'Title'), /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
      icon: "Cross",
      className: "cop-h-4 cop-w-4 cop-text-secondary"
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "cop-max-h-96 cop-overflow-auto cop-p-5"
    }, children), /*#__PURE__*/_react["default"].createElement("footer", {
      className: "cop-sticky cop-bottom-0 cop-flex cop-justify-end cop-gap-4 cop-border-0 cop-border-t cop-border-solid cop-border-card-border cop-bg-white cop-px-5 cop-py-4"
    }, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
      variant: "secondary",
      label: secondaryLabel,
      onClick: onSecondaryClick,
      disclosure: false
    }), /*#__PURE__*/_react["default"].createElement(_Button.Button, {
      variant: "primary",
      label: primaryLabel,
      onClick: onPrimaryClick,
      disclosure: false
    })))));
    return /*#__PURE__*/_reactDom["default"].createPortal(modalContent, document.body);
  };
});
